import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation } from "react-router-dom";
import { GetListOfVendorsByEmployeeID, siteURL } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const ShareAllDetailsToVendor = () => {
    const { register,formState: { errors, isSubmitting }, setValue, trigger,watch } = useForm();
    let query = useQuery();
    const guid = query.get("guid");
    const [isDisabled, setIsDisabled] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [detailsType, setDetailsType] = useState("");  // State for storing detailsType
    const {selectedCountry} = useCountry();
    
    let Guid = "";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    if (roleID == 3) {
        Guid = employerGuid
    }
    else {
        Guid = userguid
    }
    const getInterviewDetails = async () => {
        setIsLoading(true);
        const GetapiUrl = `${GetListOfVendorsByEmployeeID.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        const result = await Axios.get(GetapiUrl);
        const interviewData = result.data.filter((x) => x.vendorCompanyName && x.vendorEmail && x.vendorName);
        setVendors(interviewData);
        setIsLoading(false);
    };

    const handleClick = async () => {
        const isValid = await trigger(); // Validate all fields
        if (!isValid) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Please fill all required fields',
                showConfirmButton: false,
                timer: 2000,
            });
            return;
        }
        const selectedVendor = vendors.find(vendor => vendor.vGuid == watch("vGuid"));
        if (!selectedVendor) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Please select a valid vendor',
                showConfirmButton: false,
                timer: 2000,
            });
            return;
        }
    
        const finalURL = `${siteURL}/HomeCandidateDetails?client=${selectedVendor.vGuid}`;
        navigator.clipboard.writeText(finalURL)
            .then(() => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Copied',
                    showConfirmButton: false,
                    timer: 1000,
                });
            })
            .catch(err => {
                console.error('Failed to copy URL: ', err);
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Failed to copy URL',
                    showConfirmButton: true,
                });
            });
    };
    
    const handleVendorChange = (event) => {
        const selectedVendor = vendors.find(vendor => vendor.vGuid == event.target.value);
        if (selectedVendor) {
            setSelectedEmail(selectedVendor.vendorEmail);
            setValue("vendorEmail", selectedVendor.vendorEmail);
        } else {
            setSelectedEmail("");
            setValue("vendorEmail", "");
        }
    };

    useEffect(() => {
        getInterviewDetails();
    }, []);

    return (
        <ConsultantLayout>
            <section>
                {isLoading ? <center><LoadingSpinner /></center> :
                    <div className="container-fluid mt-4 pb-5">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                <Link to="/Employer/GetCandidatesByEmployerUserID">
                                    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
                                </Link>
                                <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Share Details to Client</h2>
                            </div>
                            <button onClick={handleClick} disabled={isSubmitting || isDisabled} className="btn btn-primary">
                                Copy
                            </button>
                        </div>

                        <hr />
                        <div class="card shadow-lg mt-5 p-5" style={{ border: "none" }}>

                            <div class="row mt-2">
                                <form>
                                    <div className="row p-3">
                                        <div className="col-sm-12 col-lg-2 col-xl-2 col-md-2"></div>
                                        <div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
                                            <select
                                                {...register("vGuid", { required: "Company Name Required" })}
                                                className={`form-control basic-form mt-3 ${errors.vGuid ? 'is-invalid' : ''}`}
                                                style={{ height: 50, borderRadius: 15 }}
                                                onChange={handleVendorChange}
                                            >
                                                <option value="">Select Company Name</option>
                                                {vendors.map((vendor, index) => (
                                                    <option key={index} value={vendor.vGuid}>{vendor.vendorName} - {vendor.vendorCompanyName}</option>
                                                ))}
                                            </select>
                                            <div className="invalid-feedback"> {errors.vGuid?.message}</div>
                                            <input
                                                type="text"
                                                {...register("vendorEmail", { required: "Email Required" })}
                                                className={`form-control basic-form mt-3 ${errors.vendorEmail ? 'is-invalid' : ''}`}
                                                placeholder="Vendor Email"
                                                value={selectedEmail}
                                                readOnly
                                            />
                                            <div className="invalid-feedback"> {errors.vendorEmail?.message}</div>
                                        </div>
                                    </div>
                                    <div class="row mb-4 mt-3 ">
                                        <div class="col-12">
                                            <Link to="/Employer/GetCandidatesByEmployerUserID">
                                                <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary " type="button">
                                                    Cancel
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </section>
        </ConsultantLayout>
    );
};

export default ShareAllDetailsToVendor;
